import { useInfiniteQuery } from 'react-query';
import { dsoOrderHistoryService } from 'services';
import { OrderHistoryFilterParams } from 'services/dso/dsoOrderHistory.service';
import { ServerStateKeysEnum } from '../../constants';

export const useDsoOrderHistory = (filters?: OrderHistoryFilterParams) => {
  return useInfiniteQuery(
    [ServerStateKeysEnum.dsoOrderHistory, filters],
    ({ pageParam = 1 }) =>
      dsoOrderHistoryService.getOrderHistory(pageParam, 10, filters),
    {
      getNextPageParam: lastPage => {
        if (typeof lastPage.currentPageNumber === 'undefined') {
          return undefined;
        }

        if (lastPage.orders.length === 0) {
          return undefined;
        }

        if (lastPage.currentPageNumber === lastPage.totalPages) {
          return undefined;
        } else {
          return lastPage.currentPageNumber + 1;
        }
      },
      staleTime: Infinity,
    }
  );
};
